export const Data = [
  {
    title: "What is the purpose of the website?",
    content: ` This website is a collection of games that assesses a user's various
    soft skills such as active memory, vocabulary, spelling, cognitive
    skills and response time/reflex.`,
  },
  {
    title: "How do I play the games?",
    content: `There are 3 games in total, you can choose whichever you want to play.
      If you want to save your scores for viewing later, you can do so by
      signing in by Email and Password or directly with your Google Account.`,
  },
  {
    title: "What are the soft skills assessed? Tell me more about it",
    content: `The 3 games assess 3 different things :- 
    
    Memory - Short-term memory is the capacity for holding, but not nmanipulating, a small amount of information in mind in an active, readily available state for a short period of time.
    
    Scramble - Tests a player's knowledge of words and their meanings, as the game requires them to identify and form words from a set of jumbled letters.
    
    Response - Tests a player's response time and hand-eye coordination to sudden changes`,
  },
];
